module.exports = __webpack_public_path__ + "img/greendatabase_mobile.6ab8315e.png";